<template>
  <div v-if="markerXSolution">
    <v-toolbar elevation="1" dark dense color="highlight" flat class="sticky">
      <!-- <v-toolbar dense flat class="sticky"> -->
      <v-toolbar-title>
        {{$store.state.productSolutions.find(x => x.id == markerXSolution.solutionId)
        ? `${$store.state.productSolutions.find(x => x.id == markerXSolution.solutionId).name}`
        : markerXSolution.solutionId ? markerXSolution.solution.name : $t('chooseSolution')}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="!readonly">
        <can I="update" a="markers">
          <template v-if="!readonly">
            <v-btn class="ml-2" depressed small color="secondary" @click="saveSolution">
              <template v-if="!$store.state.hasChanges">{{$t('save')}}</template>
              <v-badge v-else color="orange">
                <template v-slot:badge>
                  <v-icon dark small>priority_high</v-icon>
                </template>
                <span>{{$t('save')}}</span>
              </v-badge>
            </v-btn>
          </template>
        </can>
        <!-- </v-toolbar-items> -->
      </template>
      <template v-else>
        <can I="update" a="markers">
          <v-btn small depressed color="secondary" @click="lockBlueprint">{{$t('edit')}}</v-btn>
        </can>
      </template>
      <can I="delete" a="markers">
        <v-menu
          transition="scale-transition"
          origin="right top"
          v-if="!$store.state.isOffline && !readonly"
          offset-y
          style="z-index: 10"
          class="white"
          :close-on-content-click="false"
          bottom
          left
        >
          <template v-slot:activator="{ on }">
            <v-btn color="white" icon v-on="on">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-sheet flatwidth="600px">
            <v-list dense>
              <can I="delete" a="markers">
                <areyousure list_item v-on:delete="deleteMarkerXSolution(markerXSolution.id)"></areyousure>
              </can>
            </v-list>
          </v-sheet>
        </v-menu>
      </can>
    </v-toolbar>
    <div v-if="readonly" class="orange darken-1 text-center">
      <span class="white--text">{{$t("inReadOnly")}}</span>
    </div>

    <div v-bind:class="!$vuetify.breakpoint.lgAndUp ? 'container': ''">
      <div
        v-bind:class="!$vuetify.breakpoint.lgAndUp ? 'container': ''"
        v-if="!markerXSolution.solutionId && $store.state.productSolutions.find(x => x.id != markerXSolution.solutionId)"
        fluid
      >
        <v-row wrap>
          <!-- <v-col lg="6" xs="12" sm="12" class="d-flex child-flex" cols="12">
            <solutionSelector
              v-if="!readonly"
              v-on:selectedSolution="solutionSelectorSelectedSolution($event,i)"
            ></solutionSelector>
          </v-col>-->
          <!-- <v-col lg="6" xs="12" sm="12" class="d-flex child-flex" cols="12">
            <v-btn
              x-large
              @click="list = true"
              rounded
              elevation="3"
              class="white"
              outlined
              color="secondary"
            >{{$t('findInList')}}</v-btn>
          </v-col> -->
          <v-expand-transition>
            <v-col>
              <v-card class="container">
                <v-autocomplete
                  v-if="$vuetify.breakpoint.lgAndUp"
                  :disabled="readonly"
                  class="mt-3"
                  v-model="markerXSolution.solutionId"
                  :items="$store.state.productSolutions"
                  item-value="id"
                  item-text="name"
                  v-bind:label="$t('useDropdown')"
                  :clearable="true"
                  :dense="true"
                  outlined
                  return-masked-value
                  @change="changeImage();list=false"
                >
                  <template slot="selection" slot-scope="data">
                    <template>{{data.item.name}}</template>
                  </template>
                  <template slot="item" slot-scope="data">
                    <v-list-item-avatar tile>
                      <v-img v-bind:src="data.item.image ? data.item.image : emptyImage"></v-img>
                    </v-list-item-avatar>
                    <template>{{ data.item.name }}</template>
                  </template>
                </v-autocomplete>
                <v-select
                  v-else
                  :menu-props="{ bottom: true, offsetY: true }"
                  class="mt-3"
                  :disabled="readonly"
                  v-model="markerXSolution.solutionId"
                  :items="$store.state.productSolutions"
                  item-value="id"
                  item-text="name"
                  v-bind:label="$t('useDropdown')"
                  :dense="true"
                  outlined
                  return-masked-value
                  @change="changeImage();list=false"
                >
                  <template slot="selection" slot-scope="data">
                    <template>{{data.item.name}}</template>
                  </template>
                  <template slot="item" slot-scope="data">
                    <v-list-item-avatar tile>
                      <v-img v-bind:src="data.item.image ? data.item.image : emptyImage"></v-img>
                    </v-list-item-avatar>
                    <template>{{ data.item.name }}</template>
                  </template>
                </v-select>
              </v-card>
            </v-col>
          </v-expand-transition>
        </v-row>
      </div>
      <v-expand-transition>
        <div v-if="markerXSolution.solutionId">
          <template>
            <v-card tile class="d-flex">
              <div class>
                <v-img
                  aspect-ratio="1"
                  width="142"
                  :src="$store.state.productSolutions.find(x => x.id == markerXSolution.solutionId).image"
                ></v-img>
              </div>
              <div class="flex-wrap align-self-end">
                <div class="d-inline-flex flex-wrap">
                  <div v-if="!readonly" class="flex-wrap">
                    <v-btn
                      @click="markerXSolution.solutionId = null"
                      class="ma-2"
                      depressed
                      small
                      color="accent"
                    >
                      <!-- <v-icon left>mdi-pencil</v-icon> -->
                      {{$t('changeSolution')}}
                    </v-btn>
                  </div>
                  <div
                    v-if="$store.state.productSolutions.find(x => x.id == markerXSolution.solutionId).isPIM"
                    class="solutionSelector flex-wrap"
                  >
                    <v-dialog
                      fullscreen
                      v-model="pimSolutionDialog"
                      transition="slide-x-reverse-transition"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-if="!$store.state.isOffline"
                          v-on="on"
                          class="ma-2"
                          small
                          depressed
                          color="accent"
                        >{{$t('viewSolution')}}</v-btn>
                      </template>
                      <pimSolutionDetails
                        v-on:close="pimSolutionDialog = false"
                        :id="markerXSolution.solutionId"
                        :name="$store.state.productSolutions.find(x => x.id == markerXSolution.solutionId).name"
                      />
                    </v-dialog>
                  </div>
                </div>
              </div>
            </v-card>
          </template>
          <template>
            <v-card class="mt-3 mb-3">
              <v-container>
                <transition name="flip" mode="out-in">
                  <products
                    v-if="!$store.state.isOffline"
                    :productSolutionId="markerXSolution.solutionId"
                    :selectedProducts="markerXSolution.selectedProducts"
                    :readonly="readonly"
                    v-on:selected="selected"
                  ></products>
                </transition>
              </v-container>
            </v-card>
            <v-card>
              <v-container>
                <v-list subheader three-line>
                  <!-- <v-subheader>User Controls</v-subheader> -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t("properties") }}</v-list-item-title>
                      <v-list-item-subtitle
                        v-bind:class="markerXSolution.valid ?'orange--text':''"
                        v-html="markerXSolution.valid? showRequiredMessage() : attributesToString(markerXSolution)"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon v-if="!readonly">
                      <v-icon
                        :color="markerXSolution.valid?  'orange':'primary'"
                        @click="attributesDialog = true;"
                      >fa-edit</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t("dimensions") }}</v-list-item-title>
                      <v-list-item-subtitle v-html="dimensionsToString(markerXSolution)"></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon v-if="!readonly">
                      <v-icon
                        color="primary"
                        @click="markerXSolution.dimensionDialog = true"
                      >fa-edit</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list>
              </v-container>
            </v-card>
            <v-layout align-center justify-center></v-layout>
            <v-card class="mt-3 mb-3">
              <v-container>
                <v-layout>
                  <v-flex>
                    <div class="subtitle-1">{{$t('pictures')}}</div>
                    <div class="scroll-container" style="scroll-snap-type: x;">
                      <addAttachment
                        v-if="!readonly"
                        :markerXSolution="markerXSolution"
                        v-on:add-picture="addPicture"
                      ></addAttachment>
                      <div
                        v-for="(attachment,i) in markerXSolution.attachments"
                        :key="'p-'+i"
                        class="text-truncate"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{on}">
                            <div class="pa-2" v-on="on">
                              <v-img
                                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                :src="attachment.content"
                                aspect-ratio="1"
                                width="142"
                                :style="attachment.new ? 'border: 4px solid #009bd9':''"
                                class="white--text"
                                @click="zoomPicture(attachment.content)"
                              >
                                <v-card-actions class="fill-height align-end gradient">
                                  <span
                                    class="text-truncate d-inline-block"
                                  >{{attachment.createdTs.substring(0,10)}}</span>
                                  <v-spacer></v-spacer>
                                  <v-icon color="success" v-if="attachment.approved">check_circle</v-icon>
                                  <v-icon color="red" v-else>priority_high</v-icon>
                                  <!-- <v-btn
                                        
                                  >-->
                                  <v-icon
                                    color="red"
                                    v-if="(canDelete(attachment.createdTs) && attachment.new)"
                                    icon
                                    @click.stop="deletePicture(attachment)"
                                  >delete</v-icon>
                                  <!-- </v-btn> -->
                                  <areyousure
                                    icon
                                    v-else-if="(canDelete(attachment.createdTs) && !readonly && !$store.state.isOffline) || ($can('delete','blueprints') && !readonly && !$store.state.isOffline)"
                                    v-on:delete="deletePicture(attachment)"
                                    :id="attachment.id"
                                    object="attachment"
                                  ></areyousure>
                                </v-card-actions>
                                <template v-slot:placeholder>
                                  <v-row class="fill-height ma-0" align="center" justify="center">
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </div>
                          </template>
                          <span>{{`${attachment.createdBy} (${attachment.createdTs.substring(0,10)})`}}</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
            <v-card class="mt-3 mb-3">
              <v-container>
                <v-layout>
                  <v-flex>
                    <div class="subtitle-1">{{$t('newReports')}}</div>
                    <div class="scroll-container" style="scroll-snap-type: x;">
                      <div v-for="(report,i) in marker.reports" :key="'p-'+i" class="text-truncate">
                        <v-card elevation="2" class="ma-1 text-start" width="500">
                          <v-list-item three-line>
                            <v-list-item-avatar tile size="125" color="grey">
                              <v-img
                                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                :src="report.image"
                                aspect-ratio="1"
                                width="142"
                                class="white--text"
                                @click="zoomPicture(report.image)"
                              ></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-subtitle>
                                <b class="mr-2">{{$t('name')}} & {{$t('company')}}:</b>
                                {{report.name}} {{report.company}}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle>
                                <b class="mr-2">{{$t('email')}}/{{$t('phone')}}:</b>
                                {{report.email}}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle>
                                <b class="mr-2">{{$t('date')}}:</b>
                                {{report.date}}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle>
                                <b class="mr-2">{{$t('comment')}}:</b>
                                {{report.comment}}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <can I="delete" a="blueprints">
                              <areyousure2
                                :cancelbuttonText="$t('cancel')"
                                :actionButtonText="$t('ignore')"
                                :id="report.id"
                                object="report"
                                :message="$t('areyousureyouwanttoignorethis')"
                                v-on:delete="deleteReport(report)"
                              >
                                <template v-slot:action>
                                  <v-btn text color="orange" class="mr-2" depressed>{{$t('ignore')}}</v-btn>
                                </template>
                              </areyousure2>
                            </can>
                            <v-btn
                              dark
                              depressed
                              color="secondary"
                              @click="addReport(report)"
                            >{{$t('addReportToThisSolution')}}</v-btn>
                          </v-card-actions>
                        </v-card>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </template>
        </div>
      </v-expand-transition>
      <v-dialog v-model="dialog" max-width="500px">
        <!-- <div class="white"> -->
        <img v-bind:src="img" />
        <!-- </div> -->
      </v-dialog>
      <v-form lazy-validation ref="form">
        <v-dialog v-model="attributesDialog" max-width="500px">
          <v-card outlined>
            <v-card-title>
              {{$t('properties')}}
              <v-spacer></v-spacer>
              <!-- <v-menu transition="scale-transition" origin="right top" style="z-index: 10" class="white" :close-on-content-click="false" bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn @click="changeImage" color="primary" icon v-on="on">
                    <v-icon>fa-info-circle</v-icon>
                  </v-btn>
                </template>
                <v-sheet flatwidth="600px">
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon color="primary">fa-list</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>{{$t('info_attributes')}}</v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-sheet>
              </v-menu>-->
            </v-card-title>
            <v-card-text>
              <template v-for="(attribute,i) in $store.state.allAttributes.filter(x => x.visible)">
                <div v-if="attribute.qrLogAttributeClass.code == 'list'" :key="i">
                  <v-select
                    :menu-props="{ bottom: true, offsetY: true }"
                    @change="attributeSelected($event, attribute)"
                    :value="bindAttributeSelectbox(attribute)"
                    :items="attribute.qrLogAttributeListValue.filter(x => x.isActive)"
                    item-value="id"
                    :label="attribute.code"
                    :clearable="true"
                    dense
                    class="attributeSelectBoxes"
                    outlined
                    :hint="attribute.required ? $t('required'): ''"
                    persistent-hint
                    validate-on-blur
                    :required="attribute.required"
                    :rules="required(attribute.required)"
                    return-masked-value
                  >
                    <template slot="selection" slot-scope="data">
                      <template
                        v-if="data.item.description == null"
                      >{{ data.item.descriptionFallback }}</template>
                      <template v-else>{{ data.item.description }}</template>
                    </template>
                    <template slot="item" slot-scope="data">
                      <template
                        v-if="data.item.description == null"
                      >{{ data.item.descriptionFallback }}</template>
                      <template v-else>{{ data.item.description }}</template>
                    </template>
                  </v-select>
                </div>
                <div v-else :key="i">
                  <v-text-field
                    :required="attribute.required"
                    :rules="required(attribute.required)"
                    :hint="attribute.required ? $t('required'): ''"
                    validate-on-blur
                    persistent-hint
                    dense
                    :value="bindAttributeSelectbox(attribute,true)"
                    outlined
                    @change="attributeSelected($event, attribute)"
                    :label="attribute.code"
                  ></v-text-field>
                </div>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                text
                @click="attributesDialog = false;changeImage()"
              >{{$t('close')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>
      <v-dialog v-model="markerXSolution.dimensionDialog" max-width="500px">
        <v-card outlined>
          <v-card-title>
            {{$t('dimensions')}}
            <!-- <v-menu transition="scale-transition" origin="right top" style="z-index: 10" class="white" :close-on-content-click="false" bottom left>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" icon v-on="on">
                  <v-icon>fa-info-circle</v-icon>
                </v-btn>
              </template>
              <v-sheet flatwidth="600px">
                <v-list dense>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary">fa-list</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>{{$t('info_dimensions')}}</v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-sheet>
            </v-menu>-->
          </v-card-title>
          <v-card-text>
            <v-text-field
              dense
              outlined
              type="number"
              v-model="markerXSolution.amount"
              autocomplete="new-password"
              :label="$t('amount')"
            ></v-text-field>
            <v-text-field
              dense
              outlined
              autocomplete="new-password"
              :label="$t('unit')"
              box
              v-model="markerXSolution.unit"
            ></v-text-field>
            <v-text-field
              dense
              outlined
              :label="$t('width')"
              type="number"
              v-model="markerXSolution.width"
              autocomplete="new-password"
            ></v-text-field>
            <v-text-field
              dense
              outlined
              :label="$t('height')"
              type="number"
              v-model="markerXSolution.height"
              autocomplete="new-password"
            ></v-text-field>
            <v-text-field
              dense
              outlined
              :label="$t('length')"
              type="number"
              v-model="markerXSolution.length"
              autocomplete="new-password"
            ></v-text-field>
            <v-text-field
              dense
              outlined
              :label="$t('diameter')"
              type="number"
              v-model="markerXSolution.diameter"
              autocomplete="new-password"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="markerXSolution.dimensionDialog = false"
            >{{$t('close')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <savebeforeleave v-on:response="response" :dialog="saveDialog"></savebeforeleave>
  </div>  
</template>

<script>
import uuid from "uuid";
import products from "@/components/Products";
import addAttachment from "@/components/pages/Markers/AddAttachment";
import zoomPicture from "@/components/pages/Markers/ZoomPicture";
import solutionSelector from "@/components/pages/Markers/SolutionSelector/Index";
import pimSolutionDetails from "@/components/pages/solutions/PIMSolutionDetails";
import areyousure2 from "@/components/AreYouSure2";
export default {
  components: {
    products,
    addAttachment,
    zoomPicture,
    solutionSelector,
    pimSolutionDetails,
    areyousure2
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.hasChanges) {
      //if (to.name !== "MarkerXSolutionDetails") {
      this.saveDialog = true;
      //this.$store.state.hasChanges = false;
      this.to = to;
      next(false);
    } else {
      next();
    }    
  },
  data() {
    return {
      list: true,
      attributesDialog: false,
      pimSolutionDialog: false,
      markerXSolution: null,
      marker: null,
      blueprint: null,
      readonly: false,
      active: null,
      attributes: [],
      isReady: false,
      dialog: false,
      img: null,
      showDelete: false,
      isShowing: false,
      unusedAttributes: null,
      options: {
        duration: 300,
        easing: "easeInOutCubic",
        offset: 0
      },
      dimensionDialog: false,
      attributesDialog: false,
      emptyImage: require("@/assets/empty.png"),
      valid: false,
      saveDialog: false
    };
  },
  methods: {
    response(answer) {
      console.log(answer);

      if (answer) {
        this.$store.state.hasChanges = false;
        this.saveDialog = false;              
        this.saveSolution();
      } else {
        this.$store.state.hasChanges = false;        
        this.saveDialog = false;      

        this.$router.push({
          name: this.to.name,
          params: this.to.params,
        });
      }      
    },
    addReport(report) {
      // this.report.markerXSolutionsId = this.markerXSolution.id
      this.marker.reports.find(
        s => s.id == report.id
      ).markerXSolutionId = this.markerXSolution.id;
      this.marker.reports.forEach(r => {
        let id = uuid.v4();
        if (r.markerXSolutionId === this.markerXSolution.id) {
          var date = new Date();
          const attachment = {
            id: id,
            markerId: this.marker.id,
            markerXSolutionsId: r.markerXSolutionId,
            name: "report.jpg",
            content: r.image,
            approved: false,
            createdBy: "REPORTED",
            createdTs: date.toJSON(),
            reportId: r.id,
            new: true
          };
          this.marker.markerXSolutions
            .find(x => x.id == attachment.markerXSolutionsId)
            .attachments.unshift(attachment);
          this.$store.commit("updateMarker", this.marker);
          this.marker.reports = this.marker.reports.filter(x => x.id != r.id);
        }
      });
    },
    deleteReport(report) {
      this.marker.reports = this.marker.reports.filter(p => p.id != report.id);
      // if (this.marker.reports.length === 0) {
      this.$store.commit("updateMarker", this.marker);
      // }
    },
    deleteMarkerXSolution(id) {
      if (this.marker.markerXSolutions.find(x => x.id == id).new) {
        this.marker.markerXSolutions = this.marker.markerXSolutions.filter(
          x => x.id != id
        );
      } else {
        if (this.$store.state.isOffline) {
          let offForm = {
            deleteMarkerXSolution: id
          };
          this.$store.state.offForm.push(offForm);
        } else {
          this.$http
            .deleteMarkerXSolution(id)
            .then(res => {
              this.marker.markerXSolutions = this.marker.markerXSolutions.filter(
                x => x.id != id
              );
              this.$store.commit("updateMarker", this.marker);
              this.$noty.success('<i class="fas fa-check"></i>');
            })
            .catch(err => {
              console.log(err);
              this.$noty.error(this.$t("error"));
            });
        }
      }

      this.$store.state.previous.params.deleteMarkerXSolution = this.marker;
      this.$router.push({
        name: this.$store.state.previous.name,
        params: this.$store.state.previous.params
      });
    },
    bindAttributeSelectbox(attribute, textbox) {
      if (this.markerXSolution.solutionId) {
        if (textbox) {
          if (
            this.markerXSolution.qrLogAttributeXMarkerXSolutions.some(
              x => x.qrLogAttributeId == attribute.id
            )
          ) {
            return this.markerXSolution.qrLogAttributeXMarkerXSolutions.filter(
              x => x.qrLogAttributeId == attribute.id
            )[0].value;
          }
        } else {
          if (
            this.markerXSolution.qrLogAttributeXMarkerXSolutions.length > 0 &&
            this.markerXSolution.qrLogAttributeXMarkerXSolutions.some(
              s => s.qrLogAttributeId == attribute.id
            )
          ) {
            return attribute.qrLogAttributeListValue.filter(
              s =>
                s.id ==
                this.markerXSolution.qrLogAttributeXMarkerXSolutions.filter(
                  x => x.qrLogAttributeId == attribute.id
                )[0].qrLogAttributeListValueId
            ).length > 0
              ? attribute.qrLogAttributeListValue.filter(
                  s =>
                    s.id ==
                    this.markerXSolution.qrLogAttributeXMarkerXSolutions.filter(
                      x => x.qrLogAttributeId == attribute.id
                    )[0].qrLogAttributeListValueId
                )[0].id
              : null;
          }
        }

        // this.changeImage();
      }
    },
    attributeSelected(value, attribute) {
      if (
        this.markerXSolution.qrLogAttributeXMarkerXSolutions.some(
          x => x.qrLogAttributeId == attribute.id
        )
      ) {
        this.markerXSolution.qrLogAttributeXMarkerXSolutions.forEach(
          (qaxmsx, i) => {
            if (attribute.id == qaxmsx.qrLogAttributeId) {
              if (value == undefined) {
                qaxmsx.value = null;
                qaxmsx.qrLogAttributeListValueId = null;
              } else {
                if (this.$validator.isUUID(value)) {
                  qaxmsx.qrLogAttributeListValueId = value;
                  return;
                } else {
                  qaxmsx.value = value;
                  return;
                }
              }
            }
          }
        );
      } else {
        this.markerXSolution.qrLogAttributeXMarkerXSolutions.push({
          id: uuid.v4(),
          markerXSolutionsId: this.markerXSolution.id,
          qrLogAttributeId: attribute.id,
          qrLogAttributeListValueId: this.$validator.isUUID(value)
            ? value
            : null,
          value: !this.$validator.isUUID(value) ? value : null
        });
      }
      this.changeImage();
    },
    solutionSelectorSelectedSolution(event, markerXSolutionIndex) {
      this.markerXSolution.solutionId = event.solution.Id;

      this.markerXSolution.qrLogAttributeXMarkerXSolutions.forEach(
        (qaxmxs, i) => {
          this.$store.state.allAttributes.forEach((atr, o) => {
            atr.qrLogAttributeListValue.forEach(listvalue => {
              event.taxonomies.forEach(taxId => {
                if (atr.qrLogAttributeListValue.some(x => x.id == taxId)) {
                  if (
                    taxId == listvalue.id &&
                    qaxmxs.qrLogAttributeId == atr.id
                  ) {
                    this.markerXSolution.qrLogAttributeXMarkerXSolutions[
                      i
                    ].qrLogAttributeListValueId = taxId;
                  }
                }
              });
            });
          });
        }
      );

      this.$refs.form.validate();
      this.changeImage();
    },
    required(required) {
      if (required) {
        return [
          v =>
            v != "00000000-0000-0000-0000-000000000000" ||
            `${this.$t("required")}`,
          v => !!v || `${this.$t("required")}`
        ];
      }
    },
    showRequiredMessage() {
      return this.$t("fillinrequiredfields");
    },
    attributesToString(mxs) {
      let text = "";

      mxs.qrLogAttributeXMarkerXSolutions.forEach(x => {
        if (
          this.$store.state.allAttributes.some(f => f.id == x.qrLogAttributeId)
        ) {
          if (!x.value) {
            let attribute = this.$store.state.allAttributes
              .filter(f => f.id == x.qrLogAttributeId)[0]
              .qrLogAttributeListValue.find(
                z => z.id == x.qrLogAttributeListValueId
              );
            if (attribute) {
              text += `<small class="subtitle-2">${
                this.$store.state.allAttributes.filter(
                  f => f.id == x.qrLogAttributeId
                )[0].code
              }</small>: ${attribute.description}, `;
            }
          } else {
            text += `${
              this.$store.state.allAttributes.filter(
                f => f.id == x.qrLogAttributeId
              )[0].code
            }: ${x.value}, `;
          }
        }
      });
      // this.changeImage();
      return text;
    },
    dimensionsToString(mxs) {
      let html = "";
      if (mxs.amount != undefined) {
        html += `<small class="subtitle-2">${this.$t("amount")}</small>: ${
          mxs.amount
        },`;
      }
      if (mxs.unit != undefined) {
        html += `<small class="subtitle-2"> ${this.$t("unit")}
        </small>: ${mxs.unit},`;
      }
      if (mxs.width != undefined) {
        html += `<small class="subtitle-2"> ${this.$t("width")}</small>: ${
          mxs.width
        },`;
      }
      if (mxs.height != undefined) {
        html += `<small class="subtitle-2">${this.$t("height")}</small>: ${
          mxs.height
        },`;
      }
      if (mxs.length != undefined) {
        html += `<small class="subtitle-2">${this.$t("length")}</small>: ${
          mxs.length
        },`;
      }
      if (mxs.diameter != undefined) {
        html += `${this.$t("diameter")}: ${mxs.diameter}`;
      }
      return html;
    },
    selected(solutionId, selected) {
      this.marker.markerXSolutions.forEach(mxs => {
        if (mxs.solutionId == solutionId) {
          mxs.selectedProducts = selected.reduce((res, x) => {
            if (x.selected) {
              var someNewValue = {
                id: uuid.v4(),
                markerXSolutionsId: mxs.id,
                productId: x.id
              };
              res.push(someNewValue);
            }
            return res;
          }, []);
        }
      });
    },
    zoomPicture(img) {
      this.img = img;
      this.dialog = true;
    },
    deletePicture(attachment) {
      this.markerXSolution.attachments = this.markerXSolution.attachments.filter(
        p => p.id != attachment.id
      );
      this.$store.commit("updateMarker", this.marker);
    },
    addPicture(picture) {
      this.markerXSolution.attachments.unshift(picture);
      this.$store.commit("updateMarker", this.marker);
    },
    canDelete(date) {
      if (date.substring(0, 10) == new Date().toLocaleDateString("fr-CA"))
        //yyyy-MM-dd
        return true;
      else return false;
    },
    goBackToMarker() {
      this.$router.push({
        name: this.readonly ? "MarkerDetails" : "EditMarkerDetails",
        params: { id: this.$route.params.id }
      });
    },
    saveSolution() {
      this.$store.state.previous.params.saveMarker = true;
      this.$router.push({
        name: this.$store.state.previous.name,
        params: this.$store.state.previous.params
      });
    },
    lockBlueprint() {
      this.$store.state.readyForOffline = false
      this.$store.state.previous.params.edit = true;
      this.$router.push({
        name: this.$store.state.previous.name,
        params: this.$store.state.previous.params
      });
    },
    makeBackButton() {
      this.$store.state.previous = {
        name: this.readonly ? "MarkerDetails" : "EditMarkerDetails",
        params: {
          id: this.markerXSolution.markerId,
          marker: this.$route.params.marker,
          blueprint: this.$route.params.blueprint
        },
        breadcrumb: this.$t("marker")
      };
    },
    changeImage() {
      if (this.markerXSolution.solutionId) {
        this.markerXSolution.product = this.$store.state.productSolutions.find(
          x => x.id == this.markerXSolution.solutionId
        ).image;
      }

      //using form to check required attributes
      if (this.$refs.form) {
        // if (this.markerXSolution.attributesDialog == true) {
        this.$nextTick(() => {
          if (this.$refs.form.validate()) {
            this.markerXSolution.valid = false;
            this.$forceUpdate();
          } else {
            this.markerXSolution.valid = true;
            this.$forceUpdate();
          }
        });

        // }
        // else{
        if (
          this.markerXSolution.qrLogAttributeXMarkerXSolutions.filter(
            x =>
              this.$store.state.allAttributes
                .filter(x => x.required)
                .some(s => s.id == x.qrLogAttributeId) &&
              (x.qrLogAttributeListValueId != null || x.value != null)
          )
        ) {
          this.markerXSolution.valid = true;
        } else {
          this.markerXSolution.valid = false;
        }
        // }
      } else {
        // if (
        //   this.markerXSolution.qrLogAttributeXMarkerXSolutions.some(
        //     s =>
        //       s.qrLogAttributeId == x.id &&
        //       (s.qrLogAttributeListValueId != null || s.value != null)
        //   )
        // ) {
        //   console.log("1");
        //   this.markerXSolution.valid = false;
        // } else {
        //   console.log(2, this.markerXSolution);
        //   this.markerXSolution.valid = true;
        // }

        if (
          this.markerXSolution.qrLogAttributeXMarkerXSolutions.filter(
            x =>
              this.$store.state.allAttributes
                .filter(x => x.required)
                .some(s => s.id == x.qrLogAttributeId) &&
              (x.qrLogAttributeListValueId != null || x.value != null)
          )
        ) {
          this.markerXSolution.valid = true;
        } else {
          this.markerXSolution.valid = false;
        }
      }
    }
  },
  watch: {
    markerXSolution(n, o) {
      this.changeImage();
      try {
        n.qrLogAttributeXMarkerXSolutions.sort((a, b) =>
          a.qrLogAttribute.index > b.qrLogAttribute.index
            ? 1
            : b.qrLogAttribute.index > a.qrLogAttribute.index
            ? -1
            : 0
        );
      } catch (error) {}
    }
  },
  created() {
    if (
      this.$route.params.markerXSolution !== undefined &&
      this.$route.params.marker !== undefined &&
      this.$route.params.blueprint !== undefined
    ) {
      this.markerXSolution = this.$route.params.markerXSolution;
      this.readonly = this.$route.params.readonly;
      this.isReady = true;
      this.marker = this.$route.params.marker;
      this.blueprint = this.$route.params.blueprint;
      this.makeBackButton();
      this.changeImage();
    } else {
      this.goBackToMarker();
    }
  }
};
</script>

<style scoped>
.v-expansion-panel-content {
  display: block;
}
.v-toolbar__content {
  padding-left: 0 !important;
}
.gradient {
  background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.5));
}
.main_wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-areas:
    "solutionSelector solutionSelector solutionSelector solution_image"
    "dropdown  dropdown dropdown solution_image";
  grid-gap: 0.3rem;
}

.solutionSelector_wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    "text_solutionSelector button_solutionSelector"
    "text_solutionSelector button_solutionSelector";
  grid-gap: 0.3rem;
}
.text_solutionSelector {
  grid-area: text_solutionSelector;
}
.button_solutionSelector {
  grid-area: button_solutionSelector;
}
.solutionSelector {
  grid-area: solutionSelector;
}
.solution_image {
  grid-area: solution_image;
}
.text_dropdown {
  grid-area: text_dropdown;
}
.dropdown {
  grid-area: dropdown;
}
::-webkit-scrollbar {
  display: none;
}
.myColumn {
  margin: 20px;
  flex: 1 1 auto;
  /* min-width: 300px; */
  min-width: 150px;
}

.scroll-container {
  display: flex;
  overflow: auto;
  overflow-y: hidden;
  flex: none;
}
.scroll-container > div {
  text-align: center;
  scroll-snap-align: center;
  flex: none;
}

@media (max-width: 768px) {
  .main_wrapper {
    --auto-grid-min-size: 25rem;
    display: grid;
    grid-gap: 0.2em;
    grid-template-columns: 1fr;
    grid-template-areas:
      "solutionSelector"
      "solutionSelector"
      "solution_image"
      "dropdown";
    grid-auto-flow: dense;
  }

  .solutionSelector_wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas:
      "text_solutionSelector"
      "button_solutionSelector";
    grid-gap: 0.3rem;
  }
}

.v-dialog .v-dialog--active {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/views/markers/markerXSolutions/Details.vue